import { queryOptions } from "@tanstack/react-query";
import { costCentersList } from "../generated/sdk.gen.ts";
import { queryKeys } from "../query-keys.ts";

export const costCentersListOptions = () =>
  queryOptions({
    queryKey: queryKeys.costCenters.list(),
    queryFn: async () => {
      const { data, error } = await costCentersList();
      if (error) throw error;
      return data;
    },
  });
